import { render, staticRenderFns } from "./icon3.vue?vue&type=template&id=f3b73520&scoped=true&"
import script from "./icon3.vue?vue&type=script&lang=js&"
export * from "./icon3.vue?vue&type=script&lang=js&"
import style0 from "./icon3.vue?vue&type=style&index=0&id=f3b73520&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b73520",
  null
  
)

export default component.exports